var map = {
	"./badge_challenge_3.png": 510,
	"./badge_health_3.png": 511,
	"./badge_highfive_3.png": 512,
	"./badge_level_1_3.png": 513,
	"./badge_level_2_3.png": 514,
	"./badge_level_3_3.png": 515,
	"./badge_level_4_3.png": 516,
	"./badge_level_5_3.png": 517,
	"./badge_level_6_3.png": 518,
	"./badge_money_3.png": 519,
	"./badge_share_3.png": 520,
	"./badge_support_3.png": 521,
	"./badge_supporting_3.png": 227
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 509;


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges ^\.\/badge_.*_3\.png$
// module id = 509
// module chunks = 0